import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getValueWithPath } from './getValueWithPath';
import { inputs } from '../components/inputs';
import { UncoveredSurface } from '../components/inputs/UncoveredSurface';
import { SemiCoveredSurface } from '../components/inputs/SemiCoveredSurface';
import { ExclusiveSurface } from '../components/inputs/ExclusiveSurface';

const {
  Antiquity,
  CoveredSurface,
  Description,
  MinusPlusInput,
  Price,
  TotalSurface,
  Expenses,
  Balcony,
  Laundry,
  Rooftop,
  Yard,
  Garages,
  BuildingStage,
  BuildingLocationInBlock,
  BuildingCeilingHeight,
  BuildingAntiquity,
  BuildingCategory,
  BuildingBrightness,
  BuildingOrientation,
  BuildingState,
  BuildingDisposition,
  BuildingType
} = inputs;

const handleSwitch = (e, setData, accessor) => {
  setData(prev => ({
    ...prev,
    [accessor]: {
      ...prev[accessor],
      [e.target.id]: e.target.checked
    }
  }));
};

export const GetInput = ({
  input: { type, name, title, path, noTotal, required },
  errors,
  touched,
  values,
  setValues,
  handleChangeCarac,
  handleChangeCaracObj
}) => {
  switch (type) {
    case 'minusPlus':
      // eslint-disable-next-line no-case-declarations
      const quantityMinusPlus = getValueWithPath(values, path);

      return (
        <MinusPlusInput
          handleChangeCarac={handleChangeCarac}
          name={name}
          title={title}
          quantity={quantityMinusPlus}
          noCenter
        />
      );

    case 'switch':
    case 'checkbox':
      const checkboxValue = getValueWithPath(values, path);

      return (
        <Form.Group className="d-flex gap-2 align-items-center">
          <Form.Check
            type={type}
            id={name}
            onChange={e =>
              handleSwitch(
                e,
                setValues,
                path.includes('characteristics')
                  ? 'characteristics'
                  : 'ambiences_types'
              )
            }
            checked={checkboxValue}
          />

          <Form.Label className="m-0">
            {required ? title + ' *' : title}
          </Form.Label>
        </Form.Group>
      );

    case 'totalSurface':
      return (
        <TotalSurface errors={errors} touched={touched} noTotal={noTotal} />
      );

    case 'coveredSurface':
      return <CoveredSurface errors={errors} touched={touched} />;

    case 'uncoveredSurface':
      return <UncoveredSurface errors={errors} touched={touched} />;

    case 'semiCoveredSurface':
      return <SemiCoveredSurface errors={errors} touched={touched} />;

    case 'exclusiveSurface':
      return <ExclusiveSurface errors={errors} touched={touched} />;

    case 'antiquity':
      return (
        <Antiquity
          errors={errors}
          touched={touched}
          values={values}
          setValues={setValues}
        />
      );

    case 'price':
      return (
        <Price
          errors={errors}
          touched={touched}
          setValues={setValues}
          values={values}
        />
      );

    case 'expenses':
      return (
        <Expenses
          errors={errors}
          touched={touched}
          setValues={setValues}
          values={values}
        />
      );

    case 'description':
      return <Description errors={errors} touched={touched} />;

    case 'laundry':
      const valuesLaundry = getValueWithPath(values, 'characteristics.laundry');
      const errorsLaundry = getValueWithPath(errors, 'characteristics.laundry');
      const touchedLaundry = getValueWithPath(
        touched,
        'characteristics.laundry'
      );

      return (
        <Laundry
          handleChangeCaracObj={handleChangeCaracObj}
          values={valuesLaundry}
          errors={errorsLaundry}
          touched={touchedLaundry}
        />
      );

    case 'balcony':
      const valuesBalcony = getValueWithPath(values, 'characteristics.balcony');
      const errorsBalcony = getValueWithPath(errors, 'characteristics.balcony');
      const touchedBalcony = getValueWithPath(
        touched,
        'characteristics.balcony'
      );

      return (
        <Balcony
          handleChangeCaracObj={handleChangeCaracObj}
          values={valuesBalcony}
          errors={errorsBalcony}
          touched={touchedBalcony}
        />
      );

    case 'yard':
      const valuesYard = getValueWithPath(values, 'characteristics.yard');
      const errorsYard = getValueWithPath(errors, 'characteristics.yard');
      const touchedYard = getValueWithPath(touched, 'characteristics.yard');

      return (
        <Yard
          handleChangeCaracObj={handleChangeCaracObj}
          values={valuesYard}
          errors={errorsYard}
          touched={touchedYard}
        />
      );

    case 'rooftop':
      const valuesRooftop = getValueWithPath(values, 'characteristics.rooftop');
      const errorsRooftop = getValueWithPath(errors, 'characteristics.rooftop');
      const touchedRooftop = getValueWithPath(
        touched,
        'characteristics.rooftop'
      );

      return (
        <Rooftop
          handleChangeCaracObj={handleChangeCaracObj}
          values={valuesRooftop}
          errors={errorsRooftop}
          touched={touchedRooftop}
        />
      );

    case 'garages':
      const valuesGarages = getValueWithPath(values, 'characteristics.garages');
      const errorsGarages = getValueWithPath(errors, 'characteristics.garages');
      const touchedGarages = getValueWithPath(
        touched,
        'characteristics.garages'
      );

      return (
        <Garages
          handleChangeCaracObj={handleChangeCaracObj}
          values={valuesGarages}
          errors={errorsGarages}
          touched={touchedGarages}
        />
      );
    case 'buildingStage':
      const valuesBuildingStage = getValueWithPath(
        values,
        'characteristics.buildingStage'
      );
      const errorsBuildingStage = getValueWithPath(
        errors,
        'characteristics.buildingStage'
      );
      const touchedBuildingStage = getValueWithPath(
        touched,
        'characteristics.buildingStage'
      );
      return (
        <BuildingStage
          errors={errorsBuildingStage}
          touched={touchedBuildingStage}
          values={valuesBuildingStage}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingCeilingHeight':
      const valuesBuildingCeilingHeight = getValueWithPath(
        values,
        'characteristics.buildingCeilingHeight'
      );
      const errorsBuildingCeilingHeight = getValueWithPath(
        errors,
        'characteristics.buildingCeilingHeight'
      );
      const touchedBuildingCeilingHeight = getValueWithPath(
        touched,
        'characteristics.buildingCeilingHeight'
      );
      return (
        <BuildingCeilingHeight
          handleChangeCaracObj={handleChangeCaracObj}
          errors={errorsBuildingCeilingHeight}
          touched={touchedBuildingCeilingHeight}
          values={valuesBuildingCeilingHeight}
        />
      );
    case 'buildingLocationInBlock':
      const valuesBuildingLocationInBlock = getValueWithPath(
        values,
        'characteristics.buildingLocationInBlock'
      );
      const errorsBuildingLocationInBlock = getValueWithPath(
        errors,
        'characteristics.buildingLocationInBlock'
      );
      const touchedBuildingLocationInBlock = getValueWithPath(
        touched,
        'characteristics.buildingLocationInBlock'
      );

      return (
        <BuildingLocationInBlock
          errors={errorsBuildingLocationInBlock}
          touched={touchedBuildingLocationInBlock}
          values={valuesBuildingLocationInBlock}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingAntiquity':
      const valuesBuildingAntiquity = getValueWithPath(
        values,
        'characteristics.buildingAntiquity'
      );
      const errorsBuildingAntiquity = getValueWithPath(
        errors,
        'characteristics.buildingAntiquity'
      );
      const touchedBuildingAntiquity = getValueWithPath(
        touched,
        'characteristics.buildingAntiquity'
      );

      return (
        <BuildingAntiquity
          errors={errorsBuildingAntiquity}
          touched={touchedBuildingAntiquity}
          values={valuesBuildingAntiquity}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingCategory':
      const valuesBuildingCategory = getValueWithPath(
        values,
        'characteristics.buildingCategory'
      );
      const errorsBuildingCategory = getValueWithPath(
        errors,
        'characteristics.buildingCategory'
      );
      const touchedBuildingCategory = getValueWithPath(
        touched,
        'characteristics.buildingCategory'
      );

      return (
        <BuildingCategory
          errors={errorsBuildingCategory}
          touched={touchedBuildingCategory}
          values={valuesBuildingCategory}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingBrightness':
      const valuesBuildingBrightness = getValueWithPath(
        values,
        'characteristics.buildingBrightness'
      );
      const errorsBuildingBrightness = getValueWithPath(
        errors,
        'characteristics.buildingBrightness'
      );
      const touchedBuildingBrightness = getValueWithPath(
        touched,
        'characteristics.buildingBrightness'
      );

      return (
        <BuildingBrightness
          errors={errorsBuildingBrightness}
          touched={touchedBuildingBrightness}
          values={valuesBuildingBrightness}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingOrientation':
      const valuesBuildingOrientation = getValueWithPath(
        values,
        'characteristics.buildingOrientation'
      );
      const errorsBuildingOrientation = getValueWithPath(
        errors,
        'characteristics.buildingOrientation'
      );
      const touchedBuildingOrientation = getValueWithPath(
        touched,
        'characteristics.buildingOrientation'
      );

      return (
        <BuildingOrientation
          errors={errorsBuildingOrientation}
          touched={touchedBuildingOrientation}
          values={valuesBuildingOrientation}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingState':
      const valuesBuildingState = getValueWithPath(
        values,
        'characteristics.buildingState'
      );
      const errorsBuildingState = getValueWithPath(
        errors,
        'characteristics.buildingState'
      );
      const touchedBuildingState = getValueWithPath(
        touched,
        'characteristics.buildingState'
      );

      return (
        <BuildingState
          errors={errorsBuildingState}
          touched={touchedBuildingState}
          values={valuesBuildingState}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingDisposition':
      const valuesBuildingDisposition = getValueWithPath(
        values,
        'characteristics.buildingDisposition'
      );
      const errorsBuildingDisposition = getValueWithPath(
        errors,
        'characteristics.buildingDisposition'
      );
      const touchedBuildingDisposition = getValueWithPath(
        touched,
        'characteristics.buildingDisposition'
      );

      return (
        <BuildingDisposition
          errors={errorsBuildingDisposition}
          touched={touchedBuildingDisposition}
          values={valuesBuildingDisposition}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    case 'buildingType':
      const valuesBuildingType = getValueWithPath(
        values,
        'characteristics.buildingType'
      );
      const errorsBuildingType = getValueWithPath(
        errors,
        'characteristics.buildingType'
      );
      const touchedBuildingType = getValueWithPath(
        touched,
        'characteristics.buildingType'
      );

      return (
        <BuildingType
          errors={errorsBuildingType}
          touched={touchedBuildingType}
          values={valuesBuildingType}
          handleChangeCaracObj={handleChangeCaracObj}
        />
      );
    default:
      return `No existe el tipo ${type}`;
  }
};

GetInput.propTypes = {
  input: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  handleChangeCarac: PropTypes.func.isRequired,
  handleChangeCaracObj: PropTypes.func.isRequired
};
